import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class MainMenu extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        this.state = {
            Languages: Translation.GetLanguages(),
            SelectedLanguage: Translation.GetLanguage(),
        };
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }
        var SHOW_MENU = window.CONFIG && window.CONFIG.SHOW_MENU; // : process.env.REACT_APP_SHOW_MENU;
        let showShop = +SHOW_MENU === 1;

        var pth = window.location.href.split("/").pop();
        return (
            <div
                className="sidebar"
                data-color="buddah"
                // data-image="assets/img/sidebar-7.jpg" // request Pavel 23.05.24
            >
                <div className="sidebar-wrapper">
                    <div className="logo">
                        {/* <a href="#" className="simple-text">
                            Ish Allah 
                        </a> */}
                    </div>
                    {pth !== "login" ? (
                        <ul className="nav">
                            {!Context.HasRight("rtax") || Context.ctx.username === "admin"
                                ? [
                                      <li key="adminmenu" className={pth == "adminmenu" ? "active" : null}>
                                          <Link to="/adminmenu">
                                              <i className="fa fa-home"></i>
                                              <p>{Translation.Trans("administration")}</p>
                                          </Link>
                                      </li>,
                                      <li
                                          key="settingsmenu"
                                          className={pth == "settingsmenu" ? "active" : null}
                                      >
                                          <Link to="/settingsmenu">
                                              <i className="fas fa-wrench"></i>
                                              <p>{Translation.Trans("settings")}</p>
                                          </Link>
                                      </li>,
                                      <li
                                          key="reportsmenu"
                                          className={pth == "reportsmenu" ? "active" : null}
                                      >
                                          <Link to="/reportsmenu">
                                              <i className="fas fa-align-justify"></i>
                                              <p>{Translation.Trans("reports")}</p>
                                          </Link>
                                      </li>,
                                      <li
                                          key="contragentsmenu"
                                          className={pth == "contragentsmenu" ? "active" : null}
                                      >
                                          <Link to="/contragentsmenu">
                                              <i className="fa fa-th"></i>
                                              <p>{Translation.Trans("contragents")}</p>
                                          </Link>
                                      </li>,

                                      <li
                                          key="shopsmenu"
                                          className={pth == "shopsmenu" ? "active" : null}
                                          style={{ display: showShop ? "block" : "none" }}
                                      >
                                          <Link to="/shopsmenu">
                                              <i className="fas fa-shopping-cart"></i>
                                              <p>{Translation.Trans("shops")}</p>
                                          </Link>
                                      </li>,
                                  ]
                                : [
                                      <li key="n18odit" className={pth == "n18odit" ? "active" : null}>
                                          <Link to="/n18odit">
                                              <i className="fas fa-align-justify"></i>
                                              <p>{Translation.Trans("n18odit")}</p>
                                          </Link>
                                      </li>,
                                      <li key="n18tables" className={pth == "n18tables" ? "active" : null}>
                                          <Link to="/n18tables">
                                              <i className="fas fa-align-justify"></i>
                                              <p>{Translation.Trans("tables")}</p>
                                          </Link>
                                      </li>,
                                  ]}
                            <li>
                                <Link to="/logout">
                                    <i className="fa fa-power-off"></i>
                                    <p>{Translation.Trans("logout")}</p>
                                </Link>
                            </li>
                        </ul>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/pages/mainmenu.js